import { z } from 'zod';

export const UpdateInstructionVersion = z.object({
  description: z
    .string({ required_error: 'instructions:version.data.description.validation.required' })
    .trim()
    .max(500, 'instructions:version.data.description.validation.maxLength')
    .optional(),
});
export type UpdateInstructionVersion = z.infer<typeof UpdateInstructionVersion>;
